import React from 'react';
import * as FiIcons from 'react-icons/fi';
import * as FaIcons from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';

const { FiMail, FiMapPin, FiPhone } = FiIcons;
const { FaFacebookF, FaLinkedinIn } = FaIcons;

const Footer = () => {
  const hudsonValleyAreas = [
    'Poughkeepsie', 'Kingston', 'Newburgh', 'Beacon', 'Middletown', 'New Paltz', 
    'Fishkill', 'Hyde Park', 'Rhinebeck', 'Cornwall', 'Goshen', 'Peekskill', 
    'Tarrytown', 'Brewster', 'Carmel', 'Cold Spring', 'Mahopac', 'Warwick'
  ];

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="w-4/5 mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="mb-6">
              <img 
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752347970938-CRCAD-logo21.png" 
                alt="CRCAD Logo" 
                className="h-12 w-auto" 
              />
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed max-w-md">
              Your local Hudson Valley partner for 3CX VoIP phone systems. We help businesses save money while getting better features and local support.
            </p>
            <div className="space-y-3 mb-6">
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiPhone} className="h-5 w-5 text-primary-400" />
                <span>+1 845-622-5486</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMail} className="h-5 w-5 text-primary-400" />
                <span>Sales@clarkritchotte.com</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMapPin} className="h-5 w-5 text-primary-400" />
                <span>Serving the Hudson Valley, NY</span>
              </div>
            </div>
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com/ClarkRitchotte" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="bg-blue-600 hover:bg-blue-700 p-2.5 rounded-full transition-colors"
                aria-label="Facebook"
              >
                <SafeIcon icon={FaFacebookF} className="h-5 w-5 text-white" />
              </a>
              <a 
                href="https://www.linkedin.com/company/10178309/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="bg-blue-700 hover:bg-blue-800 p-2.5 rounded-full transition-colors"
                aria-label="LinkedIn"
              >
                <SafeIcon icon={FaLinkedinIn} className="h-5 w-5 text-white" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Services</h3>
            <ul className="space-y-3 text-gray-300">
              <li className="hover:text-primary-400 transition-colors cursor-default">3CX Installation</li>
              <li className="hover:text-primary-400 transition-colors cursor-default">VoIP Migration</li>
              <li className="hover:text-primary-400 transition-colors cursor-default">Phone System Support</li>
              <li className="hover:text-primary-400 transition-colors cursor-default">Training & Setup</li>
              <li className="hover:text-primary-400 transition-colors cursor-default">Compliance Solutions</li>
            </ul>
          </div>
        </div>

        {/* Areas Served */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <h3 className="text-lg font-semibold mb-4">Areas We Serve in the Hudson Valley</h3>
          <p className="text-gray-400 text-sm leading-relaxed">
            {hudsonValleyAreas.join(', ')}, and surrounding communities.
          </p>
        </div>

        {/* Disclaimer */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <p className="text-gray-500 text-xs leading-relaxed uppercase tracking-wider mb-2 font-bold">
            Disclaimer
          </p>
          <p className="text-gray-400 text-sm leading-relaxed">
            3CX licenses are non-refundable once purchased. The customer is responsible for their Carrier accounts, including billing and support requests. 
            Savings estimates are based on industry averages and may vary based on your specific provider, usage patterns, and contract terms.
          </p>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-500 text-sm mb-4 md:mb-0">
            © {new Date().getFullYear()} Clark-Ritchotte Communications and Affiliated Companies. All rights reserved.
          </div>
          <button 
            onClick={scrollToTop} 
            className="text-primary-400 hover:text-primary-300 transition-colors text-sm font-medium flex items-center space-x-1"
          >
            <span>Back to Top</span>
            <span className="text-lg">↑</span>
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;